export const isCheckboxFieldWithHelpTextProps = (props) => {
    return 'error' in props;
};
